import { instance, errorService, savePreviousData } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import DynamicTable from '@/components/DynamicComponents/Projects/Grid'
import _ from 'lodash'
import Vue from 'vue'
import { showNotification } from '@/services/calculate'
import InteriorGrouping from '@/components/DynamicComponents/Projects/InteriorGrouping'
import { socketEvents } from '@/services/config'

export default {
  components: {
    DynamicTable,
    'interior-grouping': InteriorGrouping,
  },
  props: [
    'child',
    'projectData',
    'screenIndentifier',
    'dropdownData',
    'tableId',
    'screen_Name',
    'projectModule',
    'type',
    'columnSettings',
    'componentProjectKey',
  ],
  data() {
    return {
      dropdownInfo: this.dropdownData,
      savePreviousData: savePreviousData,
      loaderTable: false,
      columnDefs: [],
      loader: false,
      openCreate: false,
      allPannels: [],
      create: new Vue(),
      constructionInfoData: {
        screenName: 'Speciality Information',
        id: '',
        data: {},
      },
      activeBox: null,
      activeIndex: 0,
      visible: false,
      role: null,
      emptyImage: process.env.BASE_URL + 'resources/images/empty.png',
      buildingData: this.projectData,
      fieldName: null,
      tabKey: undefined,
      componentKey: this.componentProjectKey,
      isArchive: false,
    }
  },
  beforeMount() {
    this.isArchive = _.get(this.projectData, 'isArchive', false)
    this.loadingConfig()
  },
  created() {
    this.child.$off('addNewRecord')
    this.child.$on('addNewRecord', this.addNewRecord)
  },
  mounted() {
    this.$socketHub.$on('message-received', this.messageRecieved)
    this.$root.$off('addLevel')
    this.$root.$off('orderingTiles')
    this.$root.$off('onUpdateTakeoff')
    this.$root.$off('onCloneTakeoff')
    this.$root.$off('onDeleteTakeoff')
    const user = JSON.parse(localStorage.getItem('userDetails'))
    this.role = user.role
    this.getSpecialtyInfo()
  },
  methods: {
    loadingConfig() {
      this.columnDefs = [
        {
          rowDrag: true,
          headerName: '',
          field: 'display',
          floatingFilter: false,
          width: 3,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
        },
        {
          field: 'checkbox',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: '',
          field: 'isLocked',
          headerTooltip: 'Locked',
          width: 30,
          editable: false,
          cellRenderer: 'lockRenderer',
          cellRendererParams: {
            type: 'dynamicTable',
          },
          floatingFilter: false,
          resizable: false,
          suppressSizeToFit: true,
          hide: true,
          pinnef: 'left',
          menuTabs: [],
        },
        {
          headerName: '',
          field: 'isValidTakeoff',
          width: 5,
          hide: true,
          floatingFilter: false,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
        },
        {
          headerName: 'Contract',
          field: 'contract',
          cellStyle: { textAlign: 'left' },
          width: 100,
          cellEditor: 'selectEditor',
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Contract',
          suppressSizeToFit: true,
          resizable: true,
          cellRendererParams: {
            type: 'dynamicTable',
            dropdownName: 'contract',
            dropdownData: this.dropdownInfo,
          },
          editable: !this.isArchive,
        },
        {
          headerName: 'Category Code',
          field: 'categoryCode',
          cellEditor: 'selectEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            dropdownName: 'category',
            dropdownData: this.dropdownInfo,
          },
          width: 150,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Category Code',
          suppressSizeToFit: true,
          resizable: true,
          editable: !this.isArchive,
        },
        {
          headerName: 'Additional Description',
          field: 'additionalDescription',
          headerClass: 'header-center',
          cellStyle: { textAlign: 'center' },
          cellEditor: 'textEditor',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            placeholder: 'Additional Description',
          },
          width: 150,
          headerTooltip: 'Additional Description',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          editable: !this.isArchive,
        },
        {
          headerName: 'Takeoff Description',
          field: 'takeoff',
          cellEditor: 'autocomplete',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            name: 'takeoff_Name',
            screen: 'Project',
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Takeoff',
          resizable: true,
          width: 420,
          editable: !this.isArchive,
        },
        {
          headerName: 'Calculation',
          field: 'calculation',
          cellEditor: 'calculationEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            name: 'calculation',
            dropdownData: this.dropdownInfo.calculation,
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Calculation',
          resizable: true,
          sortable: false,
          floatingFilter: false,
          width: 100,
          editable: !this.isArchive,
        },
        {
          headerName: 'Quantity',
          field: 'quantity',
          cellEditor: 'inputNumberEditor',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            placeholder: 'Quantity',
            precision: 0,
            min: 0,
            max: 999999999,
          },
          width: 100,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Quantity',
          resizable: true,
          suppressSizeToFit: true,
          editable: !this.isArchive,
        },
        {
          headerName: 'Unit',
          field: 'unit',
          cellEditor: 'selectEditor',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'dynamicTable',
            dropdownName: 'unit',
            dropdownData: this.dropdownInfo,
          },
          width: 100,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Unit',
          resizable: true,
          suppressSizeToFit: true,
          editable: !this.isArchive,
        },
        {
          headerName: 'Unit Cost',
          field: 'unitCost',
          cellEditor: 'inputNumberEditor',
          cellRenderer: 'costPriceCellRenderer',
          cellStyle: { textAlign: 'right' },
          cellRendererParams: {
            type: 'dynamicTable',
            placeholder: 'Unit Cost',
            precision: 2,
            min: 0,
          },
          width: 120,
          headerTooltip: 'Unit Cost',
          resizable: true,
          suppressSizeToFit: true,
          editable: !this.isArchive,
        },
        {
          headerName: 'Condition Factor',
          field: 'conditionFactor',
          headerClass: 'header-center',
          cellEditor: 'selectEditor',
          wrapText: false,
          filter: 'customFilter',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            dropdownName: 'conditionFactor',
            dropdownData: this.dropdownData.condition_factor,
            name: 'conditionFactor',
            width: '350px !important',
            editable: true,
          },
          width: 150,
          headerTooltip: 'Condition Factor',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          editable: !this.isArchive,
        },
        {
          headerName: 'Multiplier',
          field: 'multiplier',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellEditor: 'inputNumberEditor',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            name: 'multiplier',
            type: 'dynamicTable',
            dataType: 'int',
            precision: 3,
          },
          width: 100,
          headerTooltip: 'Multiplier',
          suppressSizeToFit: true,
          editable: !this.isArchive,
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          cellRenderer: 'actionCellRenderer',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            screenType: 'Project',
          },
          floatingFilter: false,
          width: 60,
          resizable: false,
          suppressSizeToFit: true,
          headerTooltip: 'Action',
          pinned: 'right',
          menuTabs: [],
        },
      ]
    },

    getSpecialtyInfo() {
      this.loader = true
      const url = projectAPIs.project.asset.commonArea.details(
        this.$route.params.id,
        this.projectData.assetId,
      )
      instance
        .get(url)
        .then(res => {
          this.allPannels = _.get(res.data, 'result', [])
          _.get(res.data, 'result', []).forEach(element => {
            if (
              element.interiorGroupings &&
              element.interiorGroupings.length > 0
            ) {
              element.interiorGroupings.forEach(element => {
                element.takeoffs = []
                this.allPannels.push(element)
              })
            }
          })
          if (this.allPannels.length > 0) {
            Object.assign(this.buildingData, {
              area_Total_Building: _.get(
                this.allPannels[0],
                'areaTotalBuilding',
                0,
              ),
              area_Building_Footprint: _.get(
                this.allPannels[0],
                'areaBuildingFootprint',
                0,
              ),
              number_Of_Stories: _.get(
                this.allPannels[0],
                'numberOfStories',
                0,
              ),
              perimeter_Building_Footprint: _.get(
                this.allPannels[0],
                'perimeterBuildingFootprint',
                0,
              ),
              average_Story_Height: _.get(
                this.allPannels[0],
                'averageStoryHeight',
                0,
              ),
              totalSiteArea: _.get(this.allPannels[0], 'totalSiteArea', 0),
              numberOfBuilding: _.get(this.allPannels[0], 'numberOfBuilding', 0),
            })
          }
          this.allPannels[0]['label'] = 'Building'
          this.allPannels[0].takeoffs = []
          this.activeIndex = 0
          this.activeBox = this.allPannels[0].id
          this.getPannelData(0)
          this.loader = false
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    getPannelData(index) {
      const panels = [...this.allPannels]
      this.loaderTable = true
      const url = projectAPIs.project.asset.commonArea.takeoff.list(
        this.$route.params.id,
        this.projectData.assetId,
        this.activeBox,
      )
      instance
        .get(url)
        .then(response => {
          panels[index].takeoffs = _.get(response.data, 'result', [])
          panels[index].takeoffs.forEach(element => {
            if (element.categoryCode) {
              element.categoryCode = Number(element.categoryCode)
            }
          })
          const isValid = panels[index].takeoffs.some(i => i.isLocked)
          if (isValid) {
            const index = this.columnDefs.findIndex(
              i => i.field === 'isLocked',
            )
            this.columnDefs[index].hide = false
          }
          this.allPannels = [...panels]
          this.loaderTable = false
        })
        .catch(err => {
          this.loaderTable = false
          errorService(err)
        })
    },

    callback(index) {
      this.fieldName = null
      this.activeIndex = index
      this.activeBox = this.allPannels[index].id
      if (index === 0) {
        this.getSpecialtyInfo()
      } else {
        this.getPannelData(index)
      }
    },

    updateTakeOff(takeOff, isSocket, id, isValidTakeoff) {
      const index = this.allPannels.findIndex(i => i.id === id)
      if (index > -1) {
        this.allPannels[index].takeoffs = [...takeOff]
        this.allPannels[index].isValidTakeoff = isValidTakeoff
      }
    },

    updateBasicData(data) {
      const newData = [...this.allPannels]
      const keys = Object.keys(data)
      keys.forEach(element => {
        if (element === 'area' || element === 'perimeter') {
          this.fieldName = element
          newData[this.activeIndex][element] = Number(data[element])
        } else {
          newData[this.activeIndex][element] = data[element]
        }
      })
      this.allPannels = [...newData]
    },

    addNewRecord() {
      this.create.$emit('addRecord')
    },

    showGrouping() {
      this.visible = true
    },

    onClose(record, ids, type, key) {
      let index
      switch (type) {
        case 'add':
          this.allPannels.push(record)
          this.allPannels[0].interiorGroupings.push(record)
          break
        case 'update':
          index = this.allPannels.findIndex(i => i.id === record.id)
          this.tabKey = this.allPannels[index].id
          this.allPannels[index].label = record.label
          this.allPannels[index].value = record.value
          this.allPannels[index].area = record.area
          this.allPannels[index].perimeter = record.perimeter
          this.fieldName = key
          break
        case 'delete':
          ids.forEach(element => {
            const index = this.allPannels.findIndex(i => i.id === element.id)
            const groupIndex = this.allPannels[0].interiorGroupings.findIndex(
              i => i.id === element.id,
            )
            this.allPannels.splice(index, 1)
            this.allPannels[0].interiorGroupings.splice(groupIndex, 1)
          })
          const isDeleted = ids.some(i => i.id === this.activeBox)
          if (this.activeIndex !== 0 && isDeleted) {
            this.callback(0)
          }
          break
        case 'sequence':
          this.loader = true
          this.getSpecialtyInfo()
          break
        case 'error':
          index = this.allPannels[0].interiorGroupings.findIndex(
            i => i.id === record.id,
          )
          this.allPannels[0].interiorGroupings[index].label = record.label
          this.allPannels[0].interiorGroupings[index].value = record.value
          break
        default:
          this.visible = false
          break
      }
    },

    updateColumnSettings(request) {
      this.$emit('updateColumnSettings', request)
    },

    checkValidTab(id, isvalid) {
      const index = this.allPannels.findIndex(i => i.id === id)
      if (index > -1) {
        this.allPannels[index].isValidTakeoff = isvalid
      }
    },

    messageRecieved(message) {
      this.$notification.destroy()
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.projectSidebarUpdated) {
        this.$root.$emit('projectSideBarUpdated', message)
      } else if (data.EventType === socketEvents.commonAreaUpdated) {
        this.$root.$emit('popupUpdation', false, true, null)
        if (this.visible) {
          if (
            this.tabKey === this.activeBox &&
            (this.fieldName === 'area' || this.fieldName === 'perimeter')
          ) {
            this.tabKey = undefined
            this.callback(this.activeIndex)
          }
        } else {
          if (this.fieldName === 'area' || this.fieldName === 'perimeter') {
            this.callback(this.activeIndex)
          }
        }
      } else if (data.EventType === socketEvents.cloneProjectSpecialityInfo) {
        this.componentKey++
        this.$root.$emit('popupUpdation', false, true, null)
        this.getSpecialtyInfo()
      } else if (data.EventType === socketEvents.error) {
        showNotification('error', 'Socket', data.Result)
      }
    },
  },
}
